import { gql } from '@apollo/client';

export const LOG_USER_ACTION = gql`
  mutation LogUserAction($action: String) {
    logUserAction(action: $action) {
      timestamp
    }
  }
`;
